<template>
  <!-- Hidden file input -->
  <div class="container d-flex justify-content-center">
    <div class="row" v-if="err">
      <div class="col bg-warning">
        {{ err }}
      </div>
    </div>
    <input
      type="file"
      ref="fileInput"
      @change="uploadImage"
      style="display: none"
    />
    <!-- Camera icon as upload trigger -->
    <span v-if="!props.player.pic">
      <i
        class="bi bi-camera"
        role="button"
        @click="triggerFileInput"
      ></i> </span
    ><span v-else>
      <div class="circle-img border rounded" @click="toggleDeleteIcon()">
        <img :src="publicUrl" alt="Profile" />
      </div>
      <div class="row mt-1" v-if="delete_icon">
        <div class="col">
          <i class="bi bi-trash text-danger" @click="deletePic()"></i>
        </div>
      </div>
    </span>
  </div>
</template>
<script setup>
import { defineProps, onMounted, ref, defineEmits } from "vue";
import supabase from "@/supabase/config";
const { customAlphabet } = require("nanoid");
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(alphabet, 10);
const err = ref("");
const props = defineProps(["player"]);
const emit = defineEmits(["picUpdated"]);
const fileInput = ref(null);
const publicUrl = ref("");
const delete_icon = ref(false);
const toggleDeleteIcon = () => {
  delete_icon.value = !delete_icon.value;
};
onMounted(async () => {
  if (props.player.pic) {
    const { data, error } = await supabase.storage
      .from("images")
      .createSignedUrl(props.player.pic, 3600);

    if (data) {
      publicUrl.value = data.signedUrl;
    }
  }
});
function triggerFileInput() {
  fileInput.value?.click();
}
const uploadImage = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const extension = file.name.split(".").pop();
    const newFileName = `${nanoid(10)}.${extension}`;
    console.log("Selected file:", file.name, newFileName);
    const { data, error } = await supabase.storage
      .from("images")
      .upload("/private/" + newFileName, file);
    if (!error) {
      console.log("file uploaded=>", data.path);
      updatePathInPlayerRecord(data.path);
    } else {
      err.value = error.message;
      setTimeout(() => {
        err.value = "";
      }, 2000);
    }
  }
};
const updatePathInPlayerRecord = async (path) => {
  const { data, error } = await supabase
    .from("players")
    .update({ pic: path })
    .eq("id", props.player.id)
    .select();
  if (!error) {
    emit("picUpdated");
  }
};
const deletePic = () => {
  updatePathInPlayerRecord(null);
};
</script>
<style scoped>
.circle-img {
  width: 30px;
  height: 30px;

  overflow: hidden;
}

.circle-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
